import React, { useEffect, useRef, useState } from 'react';
import { query } from '../../core/AuthProvider';
import {
  createForme,
  getFormes,
} from '../../services/formeService/forme.service';
import Suggestion from '../../types/suggestion';
import { Preparation } from '../../models/consultation';
import useClickOutside from '../../hooks/useClickOutside';

interface IFormeSuggesterProps {
  forme: string;
  onChange: (forme: Preparation['forme']) => void;
}

const FormeSuggester: React.FC<IFormeSuggesterProps> = ({
  forme,
  onChange,
}: IFormeSuggesterProps) => {
  const inputRef = useRef(null);
  useClickOutside(inputRef, () => setDisplaySuggestions(false));
  const [searchField, setSearchField] = useState<string>(forme || '');
  const [displaySuggestions, setDisplaySuggestions] = useState<boolean>(false);
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);

  useEffect(() => {
    setSearchField(forme);
  }, [forme]);

  const handleOnChange = (suggestion: Suggestion) => {
    onChange(suggestion.titre);
    setSearchField(suggestion.titre);
    setSuggestions([]);
    setDisplaySuggestions(false);
  };

  const handleCreate = (e: any) => {
    e.preventDefault();
    if (searchField && searchField.length > 0) {
      query(createForme(searchField))
        .then((res: Suggestion) => handleOnChange(res))
        .catch(err => console.log(err));
    }
  };

  const handleSuggestions = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const searchField = e.target.value;
    setSearchField(searchField);
    if (searchField && searchField.length > 0)
      query(getFormes(searchField))
        .then(suggestions => {
          setSuggestions(suggestions);
          setDisplaySuggestions(true);
        })
        .catch(err => console.log(err));
    else setSuggestions([]);
  };

  const handleOnFocus = () => {
    setDisplaySuggestions(true);
  };

  const handleOnBlur = () => {
    setDisplaySuggestions(false);
    setSearchField(forme);
    setSuggestions([]);
  };

  return (
    <div className="forme-suggester" onFocus={handleOnFocus} ref={inputRef}>
      <form>
        <input value={searchField} onChange={handleSuggestions} />
        {searchField && searchField.length > 0 && forme !== searchField ? (
          <button type="submit" onClick={handleCreate}>
            <span className="material-icons">check</span>
          </button>
        ) : null}
      </form>
      <div style={{ position: 'relative' }}>
        {displaySuggestions ? (
          <div
            className="forme-suggestions"
            style={{ marginTop: -(suggestions.length - 1) + 'rem' }}
          >
            {suggestions.map((suggestion, index) => (
              <button
                key={`forme-${index}`}
                className="forme-suggestion"
                onClick={() => handleOnChange(suggestion)}
              >
                {suggestion.titre}
              </button>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FormeSuggester;
